import React from 'react';
import HighlightFeature, {
  ACTION_CLICK_ADD_SAVED_QUERY,
  BOTTOM_LEFT,
} from '@/components/HighlightFeature';

export const AddMoreChartsOnboarding = () => (
  <HighlightFeature
    position={BOTTOM_LEFT}
    text={
      <span>
        Click here to <b>add more charts</b> to this dashboard
      </span>
    }
    targetAction={ACTION_CLICK_ADD_SAVED_QUERY}
    hideWhenModalsOpen
  />
);
